import I18N_STRINGS from 'Jsx/CheckoutV4/i18n/language';

const getFullName = (inputEvent: React.ChangeEvent<HTMLInputElement>) => {
  let fullName = inputEvent.target.value;
  const fullNameErrorMessage = '';

  fullName = fullName.replace(/^\W+|\d+/g, '');

  const isFullNameValid = !!(fullName && fullName.length > 2);

  return {
    fullName,
    fullNameErrorMessage,
    isFullNameValid,
  };
};

export default getFullName;

export const validateFullName = ({
  inputEvent,
  isCreditCardFullName = false,
}: {
  inputEvent: React.ChangeEvent<HTMLInputElement>;
  isCreditCardFullName?: boolean;
}) => {
  const { fullName, fullNameErrorMessage, isFullNameValid } =
    getFullName(inputEvent);
  let errorMessage = fullNameErrorMessage;

  if (!fullName) {
    errorMessage = isCreditCardFullName
      ? I18N_STRINGS.REQUIRED_CARD_HOLDER
      : I18N_STRINGS.REQUIRED_FULLNAME;
  } else if (fullName.length <= 2) {
    errorMessage = isCreditCardFullName
      ? I18N_STRINGS.REQUIRED_CARD_HOLDER
      : I18N_STRINGS.INVALID_FULLNAME;
  }

  return { fullNameErrorMessage: errorMessage, isFullNameValid, fullName };
};
